<template>
  <el-dialog append-to-body :close-on-click-modal="false" @close="closeDialog" :visible.sync="showDialog" title="下载中心" width="900px">
    <el-row :gutter="10" style="margin-top: 20px;">
      <el-col :span="9">
        <span class="query-item-label">任务名称：</span>
        <el-input v-model="queryParams.taskName" clearable size="small" placeholder="请输入任务名称" class="filter-item query-item-input" @change="queryData"/>
      </el-col>
      <el-col :span="9">
        <span class="query-item-label">提交时间：</span>
        <el-date-picker
          v-model="queryParams.submitTime"
          :default-time="['00:00:00','23:59:59']"
          type="daterange"
          range-separator=":"
          size="small"
          class="date-item"
          style="width: 63%;"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="提交时间从"
          end-placeholder="提交时间至" @change="queryData"/>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="queryData({ page: 1 })">筛 选</el-button>
        <el-button type="info" plain @click="resetQuery">重 置</el-button>
      </el-col>
    </el-row>
    <el-table ref="table" v-loading="tableLoading" stripe border :data="tableData" max-height="300" style="margin-top: 20px;">
      <el-table-column label="#" type="index" align="center"></el-table-column>
      <el-table-column label="任务名称" prop="taskName" align="center"></el-table-column>
      <el-table-column label="提交时间" prop="submitTime" align="center"></el-table-column>
      <el-table-column label="数量（份）" prop="fileCount" align="center">
        <template v-slot="scope">
          {{ scope.row.fileCount || '/' }}
        </template>
      </el-table-column>
      <el-table-column label="文件大小" prop="fileSize" align="center">
        <template v-slot="scope">
          {{ scope.row.fileSize || '/' }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="文件类型" prop="fileStoreType" align="center">
        <template v-slot="scope">
          {{ scope.row.fileStoreType || '/' }}
        </template>
      </el-table-column> -->
      <el-table-column label="文件来源" prop="modeName" align="center">
        <template v-slot="scope">
          {{ scope.row.modeName || '未知' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" align="center">
        <template v-slot="scope">
          {{ dict.label.ASYNC_TASK_EXECUTING_STATE[scope.row.status] }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="120px">
        <template v-slot="scope">
          <el-button type="text" @click="reGen(scope.row)" v-if="scope.row.status == 3" :loading="scope.row.reGenLoading">重试</el-button>
          <el-button type="text" @click="download(scope.row)" v-if="scope.row.status == 2" :loading="scope.row.downloading">下载</el-button>
          <el-button type="text" @click="toDel(scope.row)" :loading="scope.row.delLoading">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;">
      <el-pagination
        @size-change="(size) => queryData({ size })"
        @current-change="(page) => queryData({ page })"
        :current-page="queryParams.page"
        :page-sizes="[10, 20, 100, 500]"
        :page-size="queryParams.size"
        layout="total, prev, pager, next, sizes, jumper"
        :total="queryParams.total">
      </el-pagination>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialog">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import asyncTaskApi from '@/api/asyncTask'
import { download } from '@/api/data'
import { downloadFile } from '@/utils/index'
export default {
  dicts: ['ASYNC_TASK_EXECUTING_STATE'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showDialog: this.visible,
      tableLoading: false,

      tableData: [],
      queryParams: {
        page: 1,
        size: 10,
        total: 0,
        taskName: '',
        submitTime: []
      },

      downloading: false,
      refreshInterval: null,
    }
  },
  watch: {
    visible() {
      this.showDialog = this.visible
      if (this.visible) {
        this.resetQuery()
      }
      else {
        // clearInterval(this.refreshInterval)
      }
    }
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$emit('update:visible', false)
    },
    // 重试
    reGen(row) {
      this.$set(row, 'reGenLoading', true)
      asyncTaskApi.reGen(row.id).then(res => {
        this.queryData()
      })
      .finally(() => {
        this.$set(row, 'reGenLoading', false)
      })
    },
    // 下载
    download(row) {
      this.$set(row, 'downloading', true)
      if (row.fileUrl) {
        window.open(row.fileUrl)
        this.$set(row, 'downloading', false)
      }
      else {
        download(`/api/manage/async/task/download/${row.id}`, {}).then(result => {
          downloadFile(result, row.taskName, 'zip')
        }).finally(() => {
          this.$set(row, 'downloading', false)
        })
      }
    },
    // 删除
    toDel(row) {
      this.$set(row, 'delLoading', true)
      asyncTaskApi.taskDel(row.id).then(res => {
        this.$message.success('删除成功')
        this.queryData()
      })
      .finally(() => {
        this.$set(row, 'delLoading', false)
      })
    },
    queryData(params = {}) {
      // clearInterval(this.refreshInterval)
      params = {
        ...this.queryParams,
        ...params,
      }
      if (this.queryParams.submitTime && this.queryParams.submitTime.length > 1) {
        params.submitBeginTime = params.submitTime[0]
        params.submitEndTime = params.submitTime[1]
      }
      delete params.submitTime
      this.tableLoading = true
      asyncTaskApi.taskPage(params).then(res => {
        this.tableData = res.records || []
        this.queryParams.page = res.page
        this.queryParams.size = res.size
        this.queryParams.total = res.totalCount
        // if (this.visible) {
        //   this.refreshInterval = setInterval(this.queryData, 5 * 60 * 1000)
        // }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 重置
    resetQuery() {
      this.queryParams.size = 10
      this.queryParams.page = 1
      this.queryParams.total = 0
      this.queryParams.taskName = ''
      this.queryParams.submitTime = []
      this.queryData()
    }
  }
}
</script>

<style>

</style>
